import { configureStore } from '@reduxjs/toolkit';
import navReducer from './navSlice';
import formReducer from './formSlice';
import chatReducer, { saveStateMiddleware } from './chatSlice';
import homeReducer from './homeSlice';
import servicesSlice from './serviceSlice';
import aboutSlice from './aboutSlice';


export const store = configureStore({
  reducer: {
    navigation: navReducer,
    form: formReducer,
    chat: chatReducer,
    home : homeReducer,
    services: servicesSlice,
    about: aboutSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(saveStateMiddleware),
});